let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fno6o")).then(() => parcelRequire('ca7si'));